import { Box, FormControl, InputLabel, OutlinedInput, Typography } from '@mui/material';

import { Dispatch, useState } from 'react';
import { ModalAction } from '../../../model/modal.model';
import zeplinColor from '../../../theme/Color';
import CustomButton from '../CustomButton/CustomButton';
import CustomCard from '../CustomCard/CustomCard';
import CustomModal from '../CustomModal/CustomModal';

type CustomInputModalProps = {
  isModalOpen: boolean;
  modalDispatch: Dispatch<ModalAction>;
  handleAction: any;
  inputValue: string;
  title: string;
  label: string;
  modalType: string;
};

export default function CustomInputModal({
  isModalOpen,
  modalDispatch,
  handleAction,
  inputValue,
  title,
  label,
  modalType,
}: CustomInputModalProps) {
  const [value, setValue] = useState(inputValue);

  return (
    <CustomModal
      handleClose={() => modalDispatch({ type: 'CLOSE', payload: modalType })}
      open={isModalOpen}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: { xs: '20px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '22px', xl: '32px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '10px', xl: '16px' },
              }}
            >
              <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                {title}
              </Typography>
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  {label}
                </InputLabel>
                <OutlinedInput
                  onChange={(e) => setValue(e.target.value)}
                  label='File Name'
                  defaultValue={value}
                  sx={{
                    width: '300px',
                    borderRadius: '14px',
                  }}
                />
              </FormControl>
            </Box>
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                gap: { xs: '10px', xl: '16px' },
              }}
            >
              <CustomButton
                disabled={false}
                onClick={() => modalDispatch({ type: 'CLOSE', payload: modalType })}
                variant='outlined'
                color={'primary'}
                buttonVariant='responsiveButtonMedium'
                style={{
                  flex: 1,
                  borderRadius: { xs: '10px', xl: '14px' },
                  height: { xs: '32px', xl: '48px' },
                  padding: { xs: '7px 12px', xl: '14px 24px' },
                  '&.Mui-focusVisible': { backgroundColor: zeplinColor.Neutral3 },
                  display: 'flex',
                  border: `1px solid ${zeplinColor.BasicBlack}`,
                  alignItems: 'center',
                  '&:hover': { backgroundColor: zeplinColor.Neutral3 },
                }}
                textStyle={{ color: zeplinColor.BasicBlack }}
                text={'Cancel'}
              />
              <CustomButton
                disabled={false}
                onClick={() => handleAction(value)}
                variant='contained'
                color={'primary'}
                buttonVariant='responsiveButtonMedium'
                style={{
                  flex: 1,
                  borderRadius: { xs: '10px', xl: '14px' },
                  height: { xs: '32px', xl: '48px' },
                  padding: { xs: '7px 12px', xl: '14px 24px' },
                  '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                  display: 'flex',
                  alignItems: 'center',
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={'Save'}
              />
            </Box>
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
}
